import { AssetReference } from './element-asset';
import { WidgetEvent } from './widget-events';
export const WIDGET_PROPERTY_PREFIX = 'custom:';
